import React, { useState } from 'react';

import { PLAYBOOK_BUILDER_MODE } from '../../../constants/playbookBuilder';
import { pageColumnsCommonStyles } from '../PlaybookBuilderIndex/PlaybookBuilderIndex';

import { Button } from '../../../design-system';
import { AddLineIcon } from '../../../design-system/Icons';
import BlockOptionsSelector from '../BlockOptionsSelector/BlockOptionsSelector';

const PlaybookPageRightPanel = ({ mode }) => {
    const [isBlockOptionsSelectorOpened, setIsBlockOptionsSelectorOpened] = useState(false);

    return (
        <div className={`w-[200px] min-w-[200px] ${pageColumnsCommonStyles}`}>
            {mode === PLAYBOOK_BUILDER_MODE.edit && (
                <div className="relative w-fit">
                    <Button
                        type="primary"
                        size="md"
                        text="Add Block"
                        leadingIcon={AddLineIcon}
                        onClick={() => setIsBlockOptionsSelectorOpened(true)}
                    />
                    {isBlockOptionsSelectorOpened && (
                        <BlockOptionsSelector
                            position="top-[110%] right-0"
                            isDraggableSelector
                            onClose={() => setIsBlockOptionsSelectorOpened(false)}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default PlaybookPageRightPanel;
